// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Formality = require("re-formality/src/Formality.bs.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Formality__ReactUpdate = require("re-formality/src/Formality__ReactUpdate.bs.js");

var validators_attachments = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      var attachments = param.attachments;
      var uploadedAttachments = Belt_Array.keepMap(attachments, (function (x) {
              var attachment = x.state;
              if (attachment.TAG === /* Success */3) {
                return attachment._0;
              }
              
            }));
      if (uploadedAttachments.length === attachments.length) {
        return {
                TAG: /* Ok */0,
                _0: uploadedAttachments
              };
      } else if (Belt_Array.some(attachments, (function (x) {
                switch (x.state.TAG | 0) {
                  case /* NotStarted */0 :
                  case /* InProgress */1 :
                      return true;
                  case /* Failed */2 :
                  case /* Success */3 :
                      return false;
                  
                }
              }))) {
        return {
                TAG: /* Error */1,
                _0: "UPLOAD_FAILED"
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "UPLOAD_IN_PROGRESS"
              };
      }
    })
};

var validators_text = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      var text = param.text.trim();
      if (text === "") {
        if (param.attachments.length !== 0) {
          return {
                  TAG: /* Ok */0,
                  _0: undefined
                };
        } else {
          return {
                  TAG: /* Error */1,
                  _0: "EMPTY_MESSAGE"
                };
        }
      } else {
        return {
                TAG: /* Ok */0,
                _0: text
              };
      }
    })
};

var validators = {
  visibility: undefined,
  attachments: validators_attachments,
  text: validators_text
};

function initialFieldsStatuses(_input) {
  return {
          visibility: /* Pristine */0,
          attachments: /* Pristine */0,
          text: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            visibility: /* Pristine */0,
            attachments: /* Pristine */0,
            text: /* Pristine */0
          },
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match_0 = {
    TAG: /* Ok */0,
    _0: input.visibility
  };
  var match = fieldsStatuses.attachments;
  var match_0$1 = match ? match._0 : Curry._1(validators.attachments.validate, input);
  var match$1 = fieldsStatuses.text;
  var match_0$2 = match$1 ? match$1._0 : Curry._1(validators.text.validate, input);
  var visibilityResult = match_0;
  var visibilityResult$1;
  if (visibilityResult.TAG === /* Ok */0) {
    var attachmentsResult = match_0$1;
    if (attachmentsResult.TAG === /* Ok */0) {
      var textResult = match_0$2;
      if (textResult.TAG === /* Ok */0) {
        return {
                TAG: /* Valid */0,
                output: {
                  text: textResult._0,
                  attachments: attachmentsResult._0,
                  visibility: visibilityResult._0
                },
                fieldsStatuses: {
                  visibility: /* Dirty */{
                    _0: visibilityResult,
                    _1: /* Hidden */1
                  },
                  attachments: /* Dirty */{
                    _0: attachmentsResult,
                    _1: /* Shown */0
                  },
                  text: /* Dirty */{
                    _0: textResult,
                    _1: /* Shown */0
                  }
                },
                collectionsStatuses: undefined
              };
      }
      visibilityResult$1 = visibilityResult;
    } else {
      visibilityResult$1 = visibilityResult;
    }
  } else {
    visibilityResult$1 = visibilityResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            visibility: /* Dirty */{
              _0: visibilityResult$1,
              _1: /* Hidden */1
            },
            attachments: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            },
            text: /* Dirty */{
              _0: match_0$2,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurVisibilityField */0 :
                  var result = Formality.validateFieldOnBlurWithoutValidator(state.input.visibility, state.fieldsStatuses.visibility, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  visibility: status,
                                  attachments: init.attachments,
                                  text: init.text
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurAttachmentsField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.attachments, validators_attachments, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  visibility: init.visibility,
                                  attachments: status,
                                  text: init.text
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurTextField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.text, validators_text, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  visibility: init.visibility,
                                  attachments: init.attachments,
                                  text: status
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */3 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              Curry._2(onSubmit, output, {
                                    notifyOnSuccess: (function (input) {
                                        Curry._1(dispatch, {
                                              TAG: /* SetSubmittedStatus */3,
                                              _0: input
                                            });
                                      }),
                                    notifyOnFailure: (function (error) {
                                        Curry._1(dispatch, {
                                              TAG: /* SetSubmissionFailedStatus */4,
                                              _0: error
                                            });
                                      }),
                                    reset: (function (param) {
                                        Curry._1(dispatch, /* Reset */6);
                                      }),
                                    dismissSubmissionResult: (function (param) {
                                        Curry._1(dispatch, /* DismissSubmissionResult */5);
                                      })
                                  });
                            })
                        };
                  break;
              case /* DismissSubmissionError */4 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */5 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */6 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateVisibilityField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput.visibility, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            visibility: status,
                                            attachments: init.attachments,
                                            text: init.text
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateAttachmentsField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses = {
                    contents: state.fieldsStatuses
                  };
                  var result$3 = Formality.validateDependentFieldOnChange(nextInput$1, nextFieldsStatuses.contents.text, validators_text, (function (status) {
                          var init = nextFieldsStatuses.contents;
                          return {
                                  visibility: init.visibility,
                                  attachments: init.attachments,
                                  text: status
                                };
                        }));
                  if (result$3 !== undefined) {
                    nextFieldsStatuses.contents = result$3;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, nextFieldsStatuses.contents.attachments, state.submissionStatus, validators_attachments, (function (status) {
                                    var init = nextFieldsStatuses.contents;
                                    return {
                                            visibility: init.visibility,
                                            attachments: status,
                                            text: init.text
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateTextField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$2, state.fieldsStatuses.text, state.submissionStatus, validators_text, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            visibility: init.visibility,
                                            attachments: init.attachments,
                                            text: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */3 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                visibility: /* Pristine */0,
                                attachments: /* Pristine */0,
                                text: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                visibility: /* Pristine */0,
                                attachments: /* Pristine */0,
                                text: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */4 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */5 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateVisibility: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateVisibilityField */0,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          updateAttachments: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateAttachmentsField */1,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          updateText: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateTextField */2,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          blurVisibility: (function (param) {
              Curry._1(dispatch, /* BlurVisibilityField */0);
            }),
          blurAttachments: (function (param) {
              Curry._1(dispatch, /* BlurAttachmentsField */1);
            }),
          blurText: (function (param) {
              Curry._1(dispatch, /* BlurTextField */2);
            }),
          visibilityResult: Formality.exposeFieldResult(state.fieldsStatuses.visibility),
          attachmentsResult: Formality.exposeFieldResult(state.fieldsStatuses.attachments),
          textResult: Formality.exposeFieldResult(state.fieldsStatuses.text),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.visibility || match.attachments || match.text) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              Curry._1(dispatch, /* Submit */3);
            }),
          dismissSubmissionError: (function (param) {
              Curry._1(dispatch, /* DismissSubmissionError */4);
            }),
          dismissSubmissionResult: (function (param) {
              Curry._1(dispatch, /* DismissSubmissionResult */5);
            }),
          mapSubmissionError: (function (map) {
              Curry._1(dispatch, {
                    TAG: /* MapSubmissionError */5,
                    _0: map
                  });
            }),
          reset: (function (param) {
              Curry._1(dispatch, /* Reset */6);
            })
        };
}

var initialCollectionsStatuses;

exports.validators = validators;
exports.initialFieldsStatuses = initialFieldsStatuses;
exports.initialCollectionsStatuses = initialCollectionsStatuses;
exports.initialState = initialState;
exports.validateForm = validateForm;
exports.useForm = useForm;
/* react Not a pure module */
